

















import {
  defineComponent,
  PropType,
  computed,
} from '@nuxtjs/composition-api';
import type { ProductAttachmentInterface } from '@wemade-vsf/catalog/lib/runtime/product/types';
import { useProductAttachments } from '@wemade-vsf/catalog/lib/runtime/product/composables/useProductAttachments';
import { SfButton } from '@storefront-ui/vue'

export default defineComponent({
  name: 'ProductAttachment',
  props: {
    attachment: {
      type: Object as PropType<ProductAttachmentInterface>,
      required: true
    }
  },
  components: {
    SfButton
  },
  setup (props) {
    const { getAttachmentUrl } = useProductAttachments()
    const fileType = computed(() => {
      return props.attachment.file_ext
        ? `.${props.attachment.file_ext.toUpperCase()}`
        : ''
    })

    const download = () => {
      if (process.server) return
      window.open(getAttachmentUrl(props.attachment))
    }

    return {
      download,
      fileType
    }
  }
})
